// extracted by mini-css-extract-plugin
var _1 = "UserProfileHeader-module__animatedBackground--Gzbua";
var _2 = "UserProfileHeader-module__badges--vvKPL";
var _3 = "UserProfileHeader-module__buttons--G_jAR";
var _4 = "UserProfileHeader-module__description--Fkqg4";
var _5 = "UserProfileHeader-module__desktopAvatarContainer--XKsuL";
var _6 = "UserProfileHeader-module__header--PPFoI";
var _7 = "UserProfileHeader-module__main--NEnZK";
var _8 = "UserProfileHeader-module__menuContainer--Dod81";
var _9 = "UserProfileHeader-module__mobileAvatarContainer--Iy7tA";
var _a = "UserProfileHeader-module__name--gzzQC";
var _b = "UserProfileHeader-module__nameAndTitle--wDuHb";
var _c = "UserProfileHeader-module__profile--de5eN";
var _d = "UserProfileHeader-module__title--FeGa4";
export { _1 as "animatedBackground", _2 as "badges", _3 as "buttons", _4 as "description", _5 as "desktopAvatarContainer", _6 as "header", _7 as "main", _8 as "menuContainer", _9 as "mobileAvatarContainer", _a as "name", _b as "nameAndTitle", _c as "profile", _d as "title" }
